export enum NotificationRecipientType {
  ALL_MANAGERS = 'all_managers',
  WIP_ONLY = 'wip_only',
  ALL_EMPLOYEES = 'all_employees',
  SINGLE_EMAIL = 'single_email',
}

export type SendNotificationRequest = {
  id: number;
  recipient_type: NotificationRecipientType;
  subject: string;
  message: string;
  target_email?: string;
};

export type SendNotificationResponse = {
  notification_id: number;
};
